<template>
  <!-- 综合查询 -->
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      class="emp-condition"
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isselection="true"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :fieldList="fieldList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
      @fildsClick="fildsClick"
    ></mytable>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageStart"
      :page-size="pageTotal"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageCount"
    >
    </el-pagination>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
export default {
  props: {
    number: {
      type: String,
      require: true,
    },
    conditionsC: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mixins: [tableListNew],
  components: {
    queryCondition,
    paging,
    queryBtns,
    mytable,
  },
  data() {
    return {
      conditionsMR: {},
      isShowDialog: this.show,
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      //需要单独点击的列字段名数组
      fieldList: [],
      Operatewidth: "0", //操作列的列宽
      //=======================导出相关 结束 =======================

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      pageGroupName: this.number, //  页面标识
      reportFiledsNumber: this.number, // 动态 条件、表头
    };
  },

  updated() {},
  created() {},
  mounted() {
   
  },
  activated() {},
  watch: {
    conditionsC: {
      handler(newVal, oldVal) {
        console.log("CCCCCCCCCCCCCCCVVVVVVVVVVVVV",newVal)
        this.conditionsMR = newVal;
      },
      deep: true, //深度监听
      immediate: true,
     }
  },
  methods: {
    fildsClick(row) {
      this.selectedId = row.waybillSplitId;
      this.selectedNumber = row.number;
    },
    rows() {
      return this.selectTableData;
    },
  },
};
</script>


<style scoped lang="less">
.container {
  height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
.emp-condition {
  /deep/ .el-form {
    span {
      margin-right: 10px;
    }
  }
  /deep/ .el-form-item__label {
    margin-top: 0 !important;
  }
}
</style>
